import { useEffect, useState } from 'react';
import './Features.css';
import { useBooking } from '../../context/contexts';
import { ReactComponent as DropdownIcon } from '../../assets/icn_dropdown.svg';

const Features = () => {
    const { 
        selectedCar, 
        setCurrentStep,
        services,
        loadingServices,
        servicesError,
        selectedService,
        selectService,
        selectedAddOns,
        setSelectedAddOns
    } = useBooking();

    const [showIncludedServices, setShowIncludedServices] = useState(false);

    useEffect(() => {
        if (!selectedCar) {
            setCurrentStep(0);
        }
    }, [selectedCar, setCurrentStep]);

    if (loadingServices) {
        return <div className="loading">Loading services...</div>;
    }

    if (servicesError) {
        return <div className="error">Error loading services: {servicesError}</div>;
    }

    if (!selectedCar) return null;

    const handleServiceSelect = (service) => {
        selectService(service);
        setSelectedAddOns([]); // Reset add-ons when changing service
    };

    const handleAddOnSelect = (addOn) => {
        setSelectedAddOns(prev => {
            const exists = prev.find(item => item.id === addOn.id);
            if (exists) {
                return prev.filter(item => item.id !== addOn.id);
            }
            return [...prev, addOn];
        });
    };

    const currentServiceData = services.find(service => service.id === selectedService?.id);

    return (
        <div className="features-container">
            <div className="features-header">
                <p className="features-pre-header">Select Services</p>
                <h1 className="features-header">
                    Pick a cleaning service
                </h1>
            </div>

            <div className='service-picklist'>
                {services.map((service) => (
                    <button
                        key={service.id}
                        className={`service-button ${selectedService?.id === service.id ? 'selected' : ''}`}
                        onClick={() => handleServiceSelect(service)}
                    >
                        {service.name}
                    </button>
                ))}
            </div>

            {selectedService && currentServiceData && (
                <div className="features-grid-container">
                    <div className="service-description">
                        <div 
                            className="included-header"
                            onClick={() => setShowIncludedServices(!showIncludedServices)}
                        >
                            <h3>Service Details</h3>
                            <DropdownIcon className={`dropdown-icon ${showIncludedServices ? 'open' : ''}`} />
                        </div>
                        {showIncludedServices && (
                            <>
                                {currentServiceData.note && (
                                    <div className="service-note">
                                        <p>{currentServiceData.note}</p>
                                    </div>
                                )}
                                {currentServiceData.service_descriptions?.length > 0 && (
                                    <div className="service-descriptions" style={{ marginTop: '25px' }}>
                                        <h4>Service Descriptions</h4>
                                        <ul>
                                            {currentServiceData.service_descriptions.map((desc, index) => (
                                                <li key={desc.id || index}>{desc.name || 'loading...'}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    {currentServiceData.service_addons?.length > 0 && (
                        <div className="add-ons-section">
                            <h3>Additional Services</h3>
                            <div className="features-grid">
                                {currentServiceData.service_addons.map((addOn) => (
                                    <button
                                        key={addOn.id}
                                        className={`feature-button ${selectedAddOns.some(item => item.id === addOn.id) ? 'selected' : ''}`}
                                        onClick={() => handleAddOnSelect(addOn)}
                                    >
                                        <span>{addOn.name}</span>
                                        <span>${addOn.price}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Features;